import React from 'react';
import {I18n} from 'react-redux-i18n';
import ReactTable, {CellProps, Row} from 'react-table';

import {Button, Card, withStyles, WithStyles} from '@material-ui/core';
import {style} from './style';

type RecentDomainsLookupsTableProps = WithStyles<typeof style> & {
  recentDomains: string[];
  // eslint-disable-next-line no-unused-vars
  lookupDomain: (domain: string) => void;
};

const DEFAULT_RECENT_ROWS = 5;

function RecentDomainsLookupsTable({
  classes,
  recentDomains,
  lookupDomain,
}: RecentDomainsLookupsTableProps) {
  const renderRecentDomain = (row: CellProps<{value: string}> & Row<{value: string}>) => (
    <Button
      className={classes.domainButton}
      disableRipple={true}
      onClick={() => lookupDomain(row.original.value)}
      data-testid="lookup-recent-domain-button"
    >
      {row.original.value}
    </Button>
  );

  const columns = [
    {
      Header: I18n.t('lookupTool.recentDomains'),
      accessor: 'value',
      filterable: false,
      sortable: false,
      Cell: renderRecentDomain,
    },
  ];

  return (
    <Card className={classes.container}>
      {/* @ts-ignore-next-line */}
      <ReactTable
        columns={columns}
        data={recentDomains.map((d) => ({value: d}))}
        filterable={false}
        sortable={false}
        showPagination={false}
        resizable={false}
        defaultPageSize={DEFAULT_RECENT_ROWS}
        pageSize={recentDomains.length || DEFAULT_RECENT_ROWS}
        noDataText={I18n.t('lookupTool.noRecentDomains')}
        data-testid="lookup-recent-domains-table"
      />
    </Card>
  );
}

export default withStyles(style)(RecentDomainsLookupsTable);
